module.exports = __webpack_public_path__ + "fonts/7f76de8.woff";